<template functional>
  <div :class="data.staticClass"
       v-on="listeners"
       class="play-btn">
    <BaseSvg name="ico-play-fill"/>
  </div>
</template>

<script>
  export default {
    name: 'PlayButton',
    data() {
      return {

      }
    }
  }
</script>

<style lang="less">

</style>